import React from 'react';
import './Content.css';
import ReactTooltip from 'react-tooltip';
import Button from './Button.js';

import Helpers from './Helpers';

class Content extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			update: "",
			datetime: "",
			data: [],
			sets: {},
			attributes: {},
			//matrix: {},
			matrix_lines: {},
			build: 0,
			adjusted: false,

			stroke_width: 2,
			extension_factor: 1,
			curved_radius: 10,

			active_country_index: null,

			// min_width_with_matrix: 760,
			max_mobile_width: 760,
			min_width_with_matrix: 10,

			show_global: false,
			global_toggle_text: "Vollständige Analyse anzeigen",

			url_corners: false,
			lang: "de",
			dictionary: {},


			ready: false,
			error: false,

		}
		this.toggle_global = this.toggle_global.bind(this)

	}

	componentDidMount() {
		this.fetchData();
		this.urlVars();

		// set resize listener
		window.addEventListener('resize', this.handleResize);
	}

	urlVars() {
		let url_corners = Helpers.getUrlVar("corners");
		if(url_corners==="true") {
			this.setState(
				{"url_corners":true}
			)
		}
		let lang = Helpers.getUrlVar("lang");
		if(lang==="fr") {
			this.setState(
				{"lang":lang}
			)
		}
	}

	define_extensions() {
		let extension_factor_local = 1;
		let curved_radius_local = 10;
		if(window.innerWidth<=this.state.max_mobile_width) {
			extension_factor_local = 0.4
			curved_radius_local = 5;
		}
		this.setState ({
			extension_factor:extension_factor_local,
			curved_radius:curved_radius_local
		})
		return extension_factor_local
	}

	
	handleResize = () => {
		this.define_extensions();
		this.setState({
			adjusted:false,
		});
	  };


	componentDidUpdate() {
		if(window.innerWidth>=this.state.min_width_with_matrix) {
				if(this.state.adjusted===false) {
				setTimeout(
					function() {
						let matrix = this.get_matrix();
						this.setState({
							matrix:matrix.matrix,
							matrix_lines:matrix.matrix_lines,
							build: this.state.build+1,
							adjusted:true
						})
					}
					.bind(this),200
				)		
			}
		}
	}

	toggle_country(id) {
		let active_country_index_local = this.state.active_country_index;
		if(active_country_index_local === null) {
			active_country_index_local = id;
			document.querySelector('.main').classList.add("country-filtered")
			document.querySelector('#g_'+id).classList.add("country-unfiltered")
		}
		else {
			if(active_country_index_local === id) {
				if(window.innerWidth<=this.state.max_mobile_width) {
					active_country_index_local = "Schweiz"
				}
				else {
					active_country_index_local = null;
				}
				
			}
			else {
				active_country_index_local = id;
			}
			if(document.querySelector('.country-unfiltered')) {
				document.querySelector('.country-unfiltered').classList.remove("country-unfiltered")
			}
		}

		if(active_country_index_local===null) {
			document.querySelector('.main').classList.remove("country-filtered")
		}
		else {
			document.querySelector('#g_'+id).classList.add("country-unfiltered")

		}
		
		this.setState({
			active_country_index:active_country_index_local
		})
	}

	get_matrix() {
		//let matrix_local = {};
		let matrix_lines_local = {};
		let vertices = document.getElementsByClassName('rankor');
		let container_ref = document.getElementById('matrix-wrapper');
		if(container_ref && vertices.length>0) {
			let container_corr_top = container_ref.getBoundingClientRect().y;
			let container_corr_left = container_ref.getBoundingClientRect().x;
			for (let i=0;i<vertices.length;i++) {
				let vertex = vertices[i];
				let matrix_line_index = vertex.id.split("__")[3];
				let attribute_id = vertex.id.split("__")[4];
				let v=vertex.getBoundingClientRect();
				let top = v.y-container_corr_top;
				let left = v.x-container_corr_left;
				let vtx = {
					id:vertex.id,
					attribute_id: attribute_id,
					top:top,
					left:left,
					cy:top+v.height/2,
					cx:left+v.width/2,
					color: vertex.style.backgroundColor,
					column_order: vertex.id.split("__")[2]
				}
				//matrix_local[vertex.id] = vtx;

				if(!matrix_lines_local.hasOwnProperty(matrix_line_index)) {
					matrix_lines_local[matrix_line_index] = {
						id: matrix_line_index,
						attribute_id: attribute_id,
						color: vertex.style.backgroundColor,
						attributes:[vtx]
					}
				}
				else {
					matrix_lines_local[matrix_line_index].attributes.push(vtx)
				}
			}
		

			Helpers.o2a(matrix_lines_local).items.map((matrix_line,l) => {
				matrix_line.attributes = Helpers.sorting(matrix_line.attributes,"column_order",1)
				return false;
			})
			
		}
		return (
			{
				//matrix:matrix_local,
				matrix_lines:matrix_lines_local
			}
		)

	}

	draw_svg(points,type) {
		let str="";
		let arr=[];
		if(type==="polyline") {
			points.map((point,k)=>{
				if(k>0){
					arr.push(point.cx-this.state.attributes[point.attribute_id].extension*this.state.extension_factor+","+point.cy);
				}
				arr.push(point.cx+","+point.cy);
				if(k<points.length-1){
					arr.push(point.cx+this.state.attributes[point.attribute_id].extension*this.state.extension_factor+","+point.cy);
				}
				return false;
			})
			str = arr.join(" ")			
		}

		if(type==="path") {
			points.map((point,k)=>{
				if(k>0){
					arr.push(
						{
							// x:point.cx-this.state.extension,
							x:point.cx-this.state.attributes[point.attribute_id].extension*this.state.extension_factor,
							y:point.cy
						}
					)
				}
				arr.push(
					{
						x:point.cx,
						y:point.cy
					}
				)
				if(k<points.length-1){
					arr.push(
						{
							x:point.cx+this.state.attributes[point.attribute_id].extension*this.state.extension_factor,
							y:point.cy
						}
					)
				}
				return false;
			})
			str = "M "+arr[0].x+" "+arr[0].y+" ";
			arr.map((point,k)=>{
				str = str+"L"+point.x+" "+point.y+" "
				return false
			})
			//str = str+" Z";
			// console.log(str)

			if(this.state.url_corners===false) {
				str = this.createRoundedPathString(arr)
			}

		}
		
		return str
	}

	createRoundedPathString(pathCoords) {
		/**
		 * Creates a coordinate path for the Path SVG element with rounded corners
		 * @param pathCoords - An array of coordinates in the form [{x: Number, y: Number}, ...]
		 */
		const path = [];
		const curveRadius = this.state.curved_radius;
	
		// Reset indexes, so there are no gaps
		pathCoords = pathCoords.slice();
	
		for (let i = 0; i < pathCoords.length; i++) {
	
		  // 1. Get current coord and the next two (startpoint, cornerpoint, endpoint) to calculate rounded curve
		  const c2Index = ((i + 1) > pathCoords.length - 1) ? (i + 1) % pathCoords.length : i + 1;
		  const c3Index = ((i + 2) > pathCoords.length - 1) ? (i + 2) % pathCoords.length : i + 2;
	
		  const c1 = pathCoords[i];
		  const c2 = pathCoords[c2Index];
		  const c3 = pathCoords[c3Index];
	
		  // 2. For each 3 coords, enter two new path commands: Line to start of curve, bezier curve around corner.
	
		  // Calculate curvePoint c1 -> c2
		  const c1c2Distance = Math.sqrt(Math.pow(c1.x - c2.x, 2) + Math.pow(c1.y - c2.y, 2));
		  const c1c2DistanceRatio = (c1c2Distance - curveRadius) / c1c2Distance;
		  const c1c2CurvePoint = [
			((1 - c1c2DistanceRatio) * c1.x + c1c2DistanceRatio * c2.x).toFixed(1),
			((1 - c1c2DistanceRatio) * c1.y + c1c2DistanceRatio * c2.y).toFixed(1)
		  ];
	
		  // Calculate curvePoint c2 -> c3
		  const c2c3Distance = Math.sqrt(Math.pow(c2.x - c3.x, 2) + Math.pow(c2.y - c3.y, 2));
		  const c2c3DistanceRatio = curveRadius / c2c3Distance;
		  const c2c3CurvePoint = [
			((1 - c2c3DistanceRatio) * c2.x + c2c3DistanceRatio * c3.x).toFixed(1),
			((1 - c2c3DistanceRatio) * c2.y + c2c3DistanceRatio * c3.y).toFixed(1)
		  ];
	
		
		if (i === 0) {
			path.push('M' + c1.x+" "+c1.y);
		}
		
		if (i === pathCoords.length - 1) {
			path.push('M' + c2c3CurvePoint.join(','));
		}
		else {
		  // Line to start of curve (L endcoord)
		  path.push('L' + c1c2CurvePoint.join(','));			
		  // Bezier line around curve (Q controlcoord endcoord)
		  path.push('Q' + c2.x + ',' + c2.y + ',' + c2c3CurvePoint.join(','));
		}


		}
		// Logically connect path to starting point again (shouldn't be necessary as path ends there anyway, but seems cleaner)
		//path.push('Z');
	
		return path.join(' ');
	}

	preProcess(data) {

		let countries_local = {}
		data.countries.map((item,k) => {
			countries_local[item.name] = item;
			return false
		})

		let sets_local = {}
		data.sets.map((item,k) => {
			item.attributes=[];
			sets_local[item.id] = item;
			return false
		})

		let data_local = Helpers.sorting(data.data,"v_covid_faelle",1)

		let global_data_local = Helpers.sorting(data.global_data,"g_land",1)
		global_data_local = Helpers.sorting(global_data_local,"g_rank",1)

		data_local.map((item,k) => {
			item['first_order'] = k
			return false
		})

		let global_attributes_local = {};
		data.global_attributes.map((item,k) => {
			global_attributes_local[item.id] = item;
			return false;
		})


		let attributes_local = {}
		data.attributes.map((item,k) => {
			attributes_local[item.id] = item;
			item.label = item.name;
			if(item.show_label*1<=0) {
				item.label = ""
			}
			// copy main data
			item.items = data_local;
			// sort by attribute
			if(item.in_matrix*1>0) {
				item.items = Helpers.sorting(item.items,item.id,item.sort_direction)
			}
			if(item.id==="land") {
				item.items = Helpers.sorting(item.items,'first_order',1)
			}
			if(item.id==="land_ranked") {
				item.items = Helpers.sorting(item.items,'first_order',1)
				// item.items = Helpers.sorting(item.items,'rank',1)
				item.items = Helpers.sorting(item.items,'rank_global',1)
			}

			if(item.id==="rank_global") {
				item.items = Helpers.sorting(item.items,'first_order',1)
				item.items = Helpers.sorting(item.items,'rank_global',1)
			}

			// get ranks from sorted items
			item.items.map((item,l) => {
				//item.first_order = item.rank-1
				item.order = l
				
				return false
			})
			// sort again by main order
			//item.items = Helpers.sorting(item.items,'order',1)


			sets_local[item.set].attributes.push(item.id)
			return false
		})

		this.define_extensions();

		let global_toggle_text_local = "Vollständige Analyse anzeigen"
		if(this.state.show_global===false) {
			global_toggle_text_local = "Vollständige Analyse anzeigen"
		}
		else {
			global_toggle_text_local = "Vollständige Analyse ausblenden"
		}

		let dictionary_local = this.createDictionary(data['de-fr']);


		this.setState({
			data: data_local,
			attributes: attributes_local,
			sets: sets_local,
			countries: countries_local,
			//extension_factor: extension_factor_local,
			global_data: global_data_local,
			global_attributes: global_attributes_local,
			global_toggle_text: global_toggle_text_local,
			dictionary: dictionary_local,
			ready: true,
			error: false,
		});

		//console.log(this.state.dictionary)

	}

		// TRANSLATION -------------------------------------------------
		translate(phrase) {
			let lang = this.state.lang;
			let output = phrase;
			if(lang==="de") {
				return phrase
			}
			else {
				if(this.state.dictionary.hasOwnProperty(phrase)) {
					if(this.state.dictionary[phrase].hasOwnProperty(lang)) {
						output = this.state.dictionary[phrase][lang];
					}
					else {
						if(this.state.ready===true) {
							//console.log(phrase)
						}
					}
				}
				else {
					if(this.state.ready===true) {
						//console.log(phrase)
					}
		
				}
				return output;
			}
			
		}
	
		createDictionary(src) {
			let local = {}
			src.map((item,k) => {
				local[item.de] = item;
				return false;
			})
			return local;
			// this.setState({
			// 	dictionary: local
			// })
		}
		// TRANSLATION -------------------------------------------------

	fetchData() {
		let d = new Date();
		let cacheBuster = (d.getMonth()+1)+"-"+d.getDate()+"-"+d.getHours()+"-"+d.getMinutes();

		let url="./data/bulk.json?"+cacheBuster;

		fetch(url)
		.then(response => response.json())
		.then(
			(response) => {
				this.setState({
					update :  response.meta.update,
					}
				)
				this.preProcess(response.data)

				//
			},
			// Note: it's important to handle errors here
			// instead of a catch() block so that we don't swallow
			// exceptions from actual bugs in components.
			(error) => {
				console.log("error")
				this.setState({
					error: true,
					ready: false
				});
			}
		)

	}

	write_value(attribute,k) {
		let value = this.translate(attribute.items[k][attribute.id])
		let nachkommastellen = attribute.nachkommastellen*1;
		if(nachkommastellen>-1) {
			value = Math.round(value*Math.pow(10,nachkommastellen))/Math.pow(10,nachkommastellen)
		}
		value = Helpers.tsnds(value);
		if(value.length>0) {
			value = value+attribute.postfix;
		}
		return value
	}

	index_to_rank(k) {
		return k*1+1;
	}

	get_heatmap_color(item,attribute) {
		let color = "#ffffff";
		let r = item[attribute.id];
		
		let r_min = 1;
		let r_max = 15;
		let b_max = 80;
		let b = 0;
		
		if(attribute.map_heat*1>0) {
			if(r.length>0) {
				r=r*1;

				// color = "#bada55";
				// if(r<=22) {
				// 	b = b_max*(r-r_min)/(r_max-r_min)
				// }
				// else {
				// 	color = "#ff636a";
				// 	r_min = 23;
				// 	r_max = 45;		
				// 	b = b_max*(r-1)/(r_max-r_min)-b_max;
				// 	b = 90-b;
				// }
			
				color = "#bada55";
				if(r<=15) {
					b = b_max*(r-r_min)/(r_max-r_min)
				}
				else if(r<=31) {
					color = "#ffcc00";
					r_min = 15;
					r_max = 31;		
					b = b_max*(r-1)/(r_max-r_min)-b_max;
					b = 80-b;
				}
				else {
					color = "#ff636a";
					r_min = 30;
					r_max = 46;		
					b = b_max*(r-1)/(r_max-r_min)-b_max;
					b = 130-b;
				}	
			}
		
			b = Math.round(b*100)/100
			color = this.increase_brightness(color,b)
		}

		return color;
	}

	toggle_global() {
		let show_global_local = this.state.show_global;
		let global_toggle_text_local = this.state.global_toggle_text
		if(show_global_local===true) {
			show_global_local = false;
			global_toggle_text_local = "Vollständige Analyse anzeigen"
		}
		else {
			show_global_local = true;
			global_toggle_text_local = "Vollständige Analyse ausblenden"
		}
		this.setState({
			show_global:show_global_local,
			global_toggle_text:global_toggle_text_local
		})
	}

	increase_brightness(hex, percent){
		// strip the leading # if it's there
		hex = hex.replace(/^\s*#|\s*$/g, '');
	
		// convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
		if(hex.length === 3){
			hex = hex.replace(/(.)/g, '$1$1');
		}
	
		var r = parseInt(hex.substr(0, 2), 16),
			g = parseInt(hex.substr(2, 2), 16),
			b = parseInt(hex.substr(4, 2), 16);
	
		return '#' +
		   ((0|(1<<8) + r + (256 - r) * percent / 100).toString(16)).substr(1) +
		   ((0|(1<<8) + g + (256 - g) * percent / 100).toString(16)).substr(1) +
		   ((0|(1<<8) + b + (256 - b) * percent / 100).toString(16)).substr(1);
	}

	render() {
		return(
			<div className={"content adjusted_"+this.state.adjusted}

			>
				<header className="header">
					<div className='header-container'>
						<h1 className='blick-header'>{this.translate("Norwegen kam am besten durch die Pandemie")}</h1>

					</div>

				</header>

				{this.state.ready === false &&
					<div className='loading'>
						<div className='spinner-ring'><div></div><div></div><div></div><div></div></div>
					</div>
				}

				{this.state.ready === true &&


				<div className="main">

					{/* <section className='section'>
						<h2>Corona-Bilanz nach zwei Jahren auf Basis von fünf Indikatoren</h2>
					</section> */}


					<section className='matrix-wrapper' id='matrix-wrapper'>

						
						<div className='canvas-wrapper'>
						{window.innerWidth>this.state.min_width_with_matrix &&
							<svg 
								className='canvas'
								xmlns="http://www.w3.org/2000/svg" 
							>

								<g className='paths' id='paths'>
								{
									Helpers.o2a(this.state.matrix_lines).items.map((matrix_line,j) => {
										//if(matrix_line.id==="11") {
											let svg = this.draw_svg(matrix_line.attributes,"path")
											return(
												<g 
													key = {matrix_line.id}
													id = {"g_"+this.state.attributes['land'].items[matrix_line.id].land}
													className = 'path-group'
												>
													<path
														key = {matrix_line.id}
														d = {svg}
														style={{
															stroke:matrix_line.color,
															fill:"none"
														}}
													></path>
																					
												</g>

											)		
										//}
									
										
									})

								}							
								</g>

						
							</svg>
						}
						</div>

						<table>
							<thead>
								<tr>
								{
									Helpers.o2a(this.state.attributes).items.map((attribute,k) => {
										if(attribute.in_matrix*1>0) {

											return(
												<th
													key={k}
												>
													<div className='label'>
														{this.translate(attribute.label)}
													</div>
													<div className='code'>
														{attribute.code}
													</div>
												</th>
											)
										}
										else {
											return false
										}
									})
								}
								</tr>
							</thead>
							

							<tbody>
								{	
									
									this.state.attributes['land'].items.map((item,k) => {
										return(
											<tr
												key = {k}
											>
												{
													Helpers.o2a(this.state.attributes).items.map((attribute,l) => {
														if(attribute.in_matrix*1>0) {
															let color = this.state.countries[this.state.attributes['land'].items[attribute.items[k].first_order].land].color
															return(
							
																<td
																	key={l}
																>
																	<div
																		className={'cell rankor cell_'+attribute.id+" cell_"+this.state.attributes['land'].items[attribute.items[k].first_order].land}
																		id={'rankor__'+k+"__"+l+"__"+attribute.items[k].first_order+"__"+attribute.id}
																		style={{
																			backgroundColor: color
																		}}
																		
																		data-tip ={"<div class='rtt-content rtt_"+attribute.id+"'><div class='rtt-title'><div class='rtt-color-code' style='background-color:"+color+";'></div>"+this.index_to_rank(k)+". "+this.translate(this.state.attributes['land'].items[attribute.items[k].first_order].land) +"</div><div class='rtt-label'>" + this.translate(attribute.name) + ": </div><div class='rtt-value'>" + this.write_value(attribute,k) + "</div></div>"}
																	
																		onClick = 	{() => {
																			if(attribute.id === "land" || attribute.id === "land_ranked") {
																				this.toggle_country(this.state.attributes['land'].items[attribute.items[k].first_order].land) 
																			}
																		}}																	
																	
																	>
																		<div className='rankor-content'
																		>
																			{this.write_value(attribute,k)}
																		</div>
																		{
																			(attribute.id==="land" || attribute.id==='land_ranked')  && 
																			<div className='rankor-content-mob'>
																				{this.state.countries[this.state.attributes['land'].items[attribute.items[k].first_order].land].short}
																			</div>
																			
																		}
																	</div>
																</td>	
															)
														
														}
														else {
															return false
														}
													
													})
												}

											</tr>
										)
									})
								}

							</tbody>

							<tfoot>
								<tr>
								{
									Helpers.o2a(this.state.attributes).items.map((attribute,k) => {
										if(attribute.in_matrix*1>0) {

											return(
												<th
													key={k}
												>
													<div className='code'>
														{attribute.code}
													</div>
												</th>
											)
										}
										else {
											return false
										}
									})
								}
								</tr>
							</tfoot>

						</table>

					

					</section>

					<section className='hint'>
						{this.translate("Wählen Sie ein Land, um es hervorzuheben") }
						<span className='hint_mobile'>
							{this.translate("; die Punkte, um Werte anzuzeigen") }
						</span>.
					</section>



					<section className='legend-wrapper'>
						<ul className='legend'>
							<li className='legend-intro-text'>
								{this.translate("Das Ranking basiert auf den fünf Indikatoren ")} <b>{this.translate("Übersterblichkeit")}</b>, <b>{this.translate("Einschränkungen")}</b>, <b>{this.translate("Wirtschaftswachstum")}</b>, <b>{this.translate("Fiskalpolitik")}</b>, <b>{this.translate("Inflation")}</b>.
							</li>
							{
								Helpers.o2a(this.state.attributes).items.map((attribute,k) => {
									if(attribute.in_matrix*1>0 && attribute.show_label*1>0) {

										return(
											<li 
												key = {k}
												className={'legend-item legend-item_'+attribute.id}
											>
												<div className='legend-item-title'>
													<div className='legend-code'>
														{attribute.code}
													</div>
													<div className='legend-name'>
														{this.translate(attribute.name)}
													</div>
												</div>
												<div className='legend-item-content'>
													<div className='legend-item-subtitle'>
														{this.translate(attribute.subtitle)}:
													</div>
													<div className='legend-note'>
														{this.translate(attribute.label_note)}
													</div>
													<div className='legend-wertung'>
														({this.translate(attribute.wertung)})
													</div>	
												</div>
												

											</li>
										)
									}
									else {
										return false
									}
								})
							}
							
						</ul>
					</section>
					<ReactTooltip
						html = {true}
						className = {'rtt'}
					/>




					{/* GLOBAL ANALYSIS ------------------------------- */}

					<section className='section_buttons'>
						<Button
							index = {true}
							active_index = {this.state.show_global}
							name = {this.translate(this.state.global_toggle_text)}
							button_handler = {this.toggle_global}
						></Button>
					</section>
					
					{this.state.show_global === true &&
					<section className='global-wrapper'>
						<table
							className='global-table'
						>
							<thead>
								<tr>

								{
									Helpers.o2a(this.state.global_attributes).items.map((attribute,l) => {
										return(
											<th
												key={l}
												className={"g-cell g-cell_"+attribute.id}
											>
											<div className='g-label'>
													{this.translate(attribute.name)}
												</div>
												<div className='g-code'>
													{attribute.code}
												</div>
											</th>
										)
									})

								}
								</tr>
							</thead>
							<tbody>
								{	
									this.state.global_data.map((item,k) => {
										return(
											<tr
												key = {k}
													className={"g-row"}
											>
												{
													Helpers.o2a(this.state.global_attributes).items.map((attribute,l) => {
														return(
															<td
																key={l}
																className={"g-cell g-cell_"+attribute.id}
																style = {{
																	backgroundColor: this.get_heatmap_color(item,attribute)
																}}
															>
																{this.translate(item[attribute.id])}
																{attribute.postfix}
																
															</td>															
														)

													})
												}
											</tr>
										)
									})
								}

							</tbody>

							<tfoot>
								<tr>

								{
									Helpers.o2a(this.state.global_attributes).items.map((attribute,l) => {
										return(
											<th
												key={l}
												className={"g-cell g-cell_"+attribute.id}
											>
												<div className='g-code'>
													{attribute.code}
												</div>
											</th>
										)
									})

								}
								</tr>
							</tfoot>

						</table>
						<p className='table-info'>{this.translate("Die Tabelle zeigt die Rangierungen aller untersuchten Kategorien pro Land.")}</p>

						<section className='section_buttons'>
							<Button
								index = {true}
								active_index = {this.state.show_global}
								name = {this.translate(this.state.global_toggle_text)}
								button_handler = {this.toggle_global}
							></Button>
						</section>

					</section>
					}

					{/* GLOBAL ANALYSIS ------------------------------- */}




	
				</div>

				}


				<footer className="blick-footer">
					{this.translate("Quellen")}: Our World in Data, The Human Mortality Database, University of Oxford, imf.org, web.boun.edu.tr/elgin/COVID.htm, OECD | {this.translate("Methodik und Analyse")}: Stefan Legge | © Blick Visuals 2022 (rtp, wla)
				</footer>
			</div>
		)
	}
}


export default Content;
